import React from 'react';
import {t} from '@lingui/core/macro';

import {IPromoCode} from 'entities/tariff';

import AdminFormModal, {IAdminEntityModalProps} from '../AdminList/AdminFormModal';
import PromoCodesForm from './PromoCodesForm';

const PromoCodesModal: React.FC<IAdminEntityModalProps<IPromoCode>> = (props) => (
    <AdminFormModal
        {...props}
        addHeader={t`Добавить промокод`}
        editHeader={t`Изменить промокод`}
        Form={PromoCodesForm}
    />
);

export default PromoCodesModal;
